import { Box, Typography } from '@mui/material'
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded'

import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'
import { RADIUS } from '@/shared/styles/radii'
import { ICON_SIZE, UI_FONT_SIZE } from '@/shared/styles/typography'

/**
 * 中断されたが内容は保存された (= interrupted-saved). mic 奪われ / OS audio session 中断で
 * 録音は止まったが、 並列録音の blob を finalize(blob) で送り SOAP を保全できたケース.
 * 喪失ではなく安心情報なので danger/warn ではなく info token (calm blue) で出す
 * (= 重要度を色強度で煽らない方針).
 */
export const InterruptionSavedBanner = () => (
  <Box
    sx={{
      backgroundColor: colorTokens.state.infoBg,
      color: colorTokens.state.infoFg,
      borderRadius: `${RADIUS.md}px`,
      py: 1,
      px: 1.5,
      display: 'flex',
      gap: 1,
      alignItems: 'flex-start',
    }}
  >
    <CheckCircleOutlineRoundedIcon
      sx={{
        color: colorTokens.state.infoFg,
        fontSize: ICON_SIZE.md,
        flexShrink: 0,
      }}
    />
    <Typography
      component="span"
      sx={{
        fontSize: UI_FONT_SIZE.label,
        lineHeight: 1.4,
      }}
    >
      録音が中断されましたが、中断直前までの内容は SOAP に保存されました。
    </Typography>
  </Box>
)
